module.exports = "<div class=gmw-input-container> <gmw-toggle-option-group ng-model=gender> <gmw-toggle-option label=\"{{'Male'|translate}}\" value=\"'M'\"> </gmw-toggle-option> <gmw-toggle-option label=\"{{'Female'|translate}}\" value=\"'F'\"> </gmw-toggle-option> </gmw-toggle-option-group> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/directives/gender-toggle/gender-toggle.html
// module id = 958
// module chunks = 0